import axios from "axios";
import { useQuery } from "react-query";

const getAnnotationStatusOverview = () =>
  axios.get("/api/aiAnnotation/getAnnotationStatusOverview").then((r) => r.data);

/**
 * Per-content-type doc-level annotation coverage:
 *   [{ contentType, publishedDocCount, annotatedDocCount, fields }]
 *
 * Shared by the "Annotate Now" widget and the dashboard "% Analysed" stat, so
 * both read from a SINGLE cached fetch (same query key — react-query dedupes).
 */
export const useGetAnnotationStatusOverview = (options = {}) =>
  useQuery("annotationStatusOverview", getAnnotationStatusOverview, {
    staleTime: 60_000,
    ...options,
  });

/**
 * Collapse the per-content-type overview into one platform-wide figure.
 *
 * "% Analysed" = annotated documents / published documents * 100, where an
 * annotated document is any published document carrying at least one
 * annotation (`annotations.tags.tags.data.0` exists, server-side).
 */
export const getAnnotationCoverage = (overview) => {
  if (!overview) return null;
  let totalPublished = 0;
  let totalAnnotated = 0;
  for (const ct of overview) {
    totalPublished += ct.publishedDocCount || 0;
    totalAnnotated += ct.annotatedDocCount || 0;
  }
  // Keep 1 decimal so small coverage (e.g. 0.4%) isn't rounded away to 0%.
  const percent =
    totalPublished > 0
      ? Math.round((totalAnnotated / totalPublished) * 1000) / 10
      : 0;
  return {
    totalPublished,
    totalAnnotated,
    unannotated: totalPublished - totalAnnotated,
    datasetCount: overview.length,
    percent,
  };
};
